exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FavoriteCount__active___SKLHw {\n  height: 39px;\n  display: inline-block;\n  border: none; }\n  .FavoriteCount__active___SKLHw > a {\n    color: #f94144; }\n\n.FavoriteCount__text___2ZzGi {\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 15px;\n  margin-right: 20px;\n  font-family: \"Poppins\"; }\n\n.FavoriteCount__favoriteIcon___36UcT {\n  width: 12px;\n  height: 12px;\n  vertical-align: initial; }\n", ""]);

// exports
exports.locals = {
	"active": "FavoriteCount__active___SKLHw",
	"text": "FavoriteCount__text___2ZzGi",
	"favoriteIcon": "FavoriteCount__favoriteIcon___36UcT"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/FavoriteCount/styles/FavoriteCount.scss
// module id = 3987
// module chunks = 6